module.exports = __webpack_public_path__ + "h5/img/shengfang.bda25d76.png";